module.exports = __webpack_public_path__ + "img/2.6ea4f4e9.jpg";